import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { prettyLetter } from 'pretty-letters';

gsap.registerPlugin(ScrollTrigger);

export default class Hero {
    constructor(){
        this.section = {
            el: document.getElementById('hero'),
            title: document.querySelector('#hero .title'),
        };

		this.carousel = {
			hero: document.getElementById('fullscreen-carousel'),
			thumbnails: document.getElementById('thumbnail-carousel'),
		};

        this.title = {
            el: document.querySelector('#hero .title'),
            letters: document.querySelectorAll('#hero .title [class*="char-"]'),
        };
    }

    init(){
        this.set();
        this.animation();
    }

    set = () => {
        prettyLetters(this.section.title, {
            charClass: 'char-',
            groupClass: 'word-',
            charTag: 'span',
            groupTag: 'span',
        });

        gsap.from('#cover .title [class*="char-"]', 2,{
            y: 200,
            autoAlpha: 0,
            stagger: .05,
            ease: 'expo.easeInOut',
        });
    }

    animation = () => {
        gsap.to(this.carousel.hero,{
            y: window.innerHeight / 2,
            autoAlpha: 0,
            ease: 'expo.easeInOut',
            scrollTrigger: {
                trigger: this.section.el,
                start: 'top top',
                // end: 'bottom +=70%',
                scrub: true
            }
        });

        gsap.to(this.carousel.thumbnails,{
            y: - window.innerHeight / 2,
            ease: 'expo.easeInOut',
            scrollTrigger: {
                trigger: this.section.el,
                start: 'top top',
                // end: 'bottom +=70%',
                scrub: .3
            }
        });
    }
}
